/**
 * シミュレータ結果のタイプ.
 */
export const SimulateResultType = {
  /** 0:成功. */
  SUCCESS: 0,
  /** 1:実行中. */
  RUNNING: 1,
  /** 9:失敗. */
  FAILURE: 9
};

export type SimulateResultType = typeof SimulateResultType[keyof typeof SimulateResultType];



// WEBPACK FOOTER //
// ./src/types/simulate-result-type.ts